import type { OptionsProps } from '@/components/atoms/select/Select';

const maritalStatusOptions: OptionsProps[] = [
  { value: 'single', label: 'Pessoa solteira' },
  { value: 'married', label: 'Pessoa casada' },
  { value: 'divorced', label: 'Pessoa divorciada' },
  { value: 'widower', label: 'Pessoa viúva' },
];

export default maritalStatusOptions;
